import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkyModalModule } from '../modal';
import { SkyResourcesModule } from '../resources';

import { SkyConfirmService } from './confirm.service';
import { SkyConfirmComponent } from './confirm.component';


export class SkyConfirmModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyConfirmComponent
  ],
  imports: [
    CommonModule,
    SkyModalModule,
    SkyResourcesModule
  ],
  exports: [
    SkyConfirmComponent
  ],
  providers: [
    SkyConfirmService
  ],
  entryComponents: [
    SkyConfirmComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
